module.exports = __webpack_public_path__ + "img/info-dialog-banner.7d5cef34.png";